export const labelTypeOptions = [
  { value: 'contains', label: 'Contains' },
  { value: 'diet', label: 'Custom' }
]

export function labelTypeDisplay(value) {
  const option = labelTypeOptions.find(option => option.value === value)
  return option ? option.label : value
}
